/* eslint-disable */
import { ActionContext } from 'vuex';
import { State } from '../state';
import { DeviceState } from './state';
import { getStoreAccessors } from 'typesafe-vuex';
import { api } from '@/api';
import { dispatchCheckApiError } from '../task/actions'
import { commitSetDevices, commitSetDeviceSpecs, commitSetDevice, commitUpdateDevice, commitDeleteDevice, commitSetDeviceSpecsList, commitGetDeviceSpecsNew, commitCreateDeviceSpecsList,commitUpdateSystem } from './mutations'
import { IDevice, IDeviceSpacs } from '@/interfaces';
type DeviceContext = ActionContext<DeviceState, State>;
export const actions = {
    async actionGetDevices(context: DeviceContext, payload: {project: number}) {
        try {
            const response = await api.getDevices(context.rootState.main.token, payload.project);
            if (response.data) {
                commitSetDevices(context, response.data);
            }
        } catch (error) {
            await dispatchCheckApiError(context, error);
        }
    },
    async actionGetDeviceSpecsList(context: DeviceContext, payload: {project: number}) {
        try {
            const response = await api.GetDeviceSpecsList(context.rootState.main.token, payload.project);
            if (response.data) {
                commitSetDeviceSpecsList(context, response.data);
            }
        } catch (error) {
            await dispatchCheckApiError(context, error);
        }
    },
    async actionGetDeviceSpecs(context: DeviceContext, payload: {project: number}) {
        try {
            const response = await api.getDeviceSpecs(context.rootState.main.token, payload.project);
            if (response.data) {
                commitSetDeviceSpecs(context, response.data);
            }
        } catch (error) {
            await dispatchCheckApiError(context, error);
        }
    },
    async actionGetDeviceSpecsNew(context: DeviceContext, payload: {project: number,size:number,page:number,search:string}) {
        try {
            const response = await api.getDeviceSpecsNew(context.rootState.main.token, payload.project,payload.page,payload.size,payload.search);
            if (response.data) {
                commitGetDeviceSpecsNew(context, response.data);
            }
        } catch (error) {
            await dispatchCheckApiError(context, error);
        }
    },
    async actionUpdateDevice(context: DeviceContext, payload: IDevice) {
        try {
            const new_remark = payload.remark
            const response = (await Promise.all([
                api.updateDevice(context.rootState.main.token, {id: payload.id, remark: payload.remark, project: payload.project,level:payload.level,status:payload.status, debug_url: payload.debug_url,note: payload.note}),
                await new Promise<void>((resolve, reject) => setTimeout(() => resolve(), 500)),
            ]))[0];
            commitUpdateDevice(context,  response.data);
        } catch (error) {
            await dispatchCheckApiError(context, error);
        }
    },
    async actionUpdateSystem(context: DeviceContext, payload: IDevice) {
        try {
            const new_remark = payload.remark
            const response = (await Promise.all([
                api.updateSystem(context.rootState.main.token, { debug_url: payload.debug_url, project: payload.project,model:payload.model,}),
                await new Promise<void>((resolve, reject) => setTimeout(() => resolve(), 500)),
            ]))[0];
            commitUpdateDevice(context,  response.data);
        } catch (error) {
            await dispatchCheckApiError(context, error);
        }
    },
    async actionCreateDevice(context: DeviceContext, payload: IDevice) {
        try {
            const response = (await Promise.all([
                api.createDevice(context.rootState.main.token, payload),
                await new Promise<void>((resolve, reject) => setTimeout(() => resolve(), 500)),
            ]))[0];
            commitSetDevice(context, response.data);
        } catch (error) {
            await dispatchCheckApiError(context, error);
        }
    },
       async actionCreateDeviceSpecsList(context: DeviceContext, payload: IDeviceSpacs) {
        try {
            const response = (await Promise.all([
                api.createDeviceSpecsList(context.rootState.main.token, payload),
                await new Promise<void>((resolve, reject) => setTimeout(() => resolve(), 500)),
            ]))[0];
            commitCreateDeviceSpecsList(context, response.data);
        } catch (error) {
            await dispatchCheckApiError(context, error);
        }
    }, 
    async actionDeleteDevice(context: DeviceContext, payload: { id: number, project: number }) {
        try {
            const response = (await Promise.all([
                api.deleteDevice(context.rootState.main.token, payload.id, payload.project),
                await new Promise<void>((resolve, reject) => setTimeout(() => resolve(), 500)),
            ]))[0];
            commitDeleteDevice(context, response.data);
        } catch (error) {
            await dispatchCheckApiError(context, error);
        }
    },
    async actionReleaseDevice(context: DeviceContext, payload: { UUID: any, project: number }) {
        try {
            const response = (await Promise.all([
                api.releaseDevice(context.rootState.main.token, payload.UUID, payload.project),
                await new Promise<void>((resolve, reject) => setTimeout(() => resolve(), 500)),
            ]))[0];
            commitDeleteDevice(context, response.data);
        } catch (error) {
            await dispatchCheckApiError(context, error);
        }
    },
};

const { dispatch } = getStoreAccessors<DeviceState, State>('');

export const dispatchGetDevices = dispatch(actions.actionGetDevices);
export const dispatchGetDeviceSpecs = dispatch(actions.actionGetDeviceSpecs);
export const dispatchGetDeviceSpecsNew = dispatch(actions.actionGetDeviceSpecsNew);
export const dispatchGetDeviceSpecsList = dispatch(actions.actionGetDeviceSpecsList);
export const dispatchUpdateDevice = dispatch(actions.actionUpdateDevice);
export const dispatchupdateSystem = dispatch(actions.actionUpdateSystem);
export const dispatchCreateDevice = dispatch(actions.actionCreateDevice);
export const dispatchCreateDeviceSpecsList = dispatch(actions.actionCreateDeviceSpecsList);
export const dispatchDeleteDevice = dispatch(actions.actionDeleteDevice);
export const dispatchReleaseDevice = dispatch(actions.actionReleaseDevice);




